import { Component, OnInit, OnDestroy } from '@angular/core';
import { PlayerService } from '../services/player.service';

@Component({
  selector: 'seek-track',
  templateUrl: './seek-track.component.html',
  styleUrls: ['./seek-track.component.css']
})
export class SeekTrackComponent implements OnInit, OnDestroy {
  private position: number = 0;
  private duration: number = 0;
  private playerEventSubscriber = null;

  constructor(private playerService: PlayerService) { }

  ngOnInit() {
    this.playerEventSubscriber = this.playerService.playerEvent.subscribe((event) => {
      if (event.type === 'currentTrack:position') {
        this.position = event.data;
      }
      if (event.type === 'currentTrack:duration') {
        this.duration = event.data;
      }
    });
  }

  onChange() {
    this.playerService.adjustSeekBarSlider(this.position);
  }

  ngOnDestroy() {
    if (this.playerEventSubscriber != null) {
      this.playerEventSubscriber.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/player/seek-track/seek-track.component.ts